module.exports = __webpack_public_path__ + "img/hamburger.8cc84f0c.svg";